import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto w-full border-t border-[#8f7e69]/20 bg-[#2c201b] py-5 text-[#d8cdbf]">
      <div className="mx-auto max-w-6xl px-4">
        <div className="text-center text-xs uppercase tracking-[0.18em]">
          <p>© {currentYear} The Wandering Fool.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
